var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name && _vm.itemId)?_c('router-link',{staticClass:"cur_p un_menuitem",attrs:{"tag":"div","activeClass":"active","to":'/category/' + _vm.category.id + '/item/' + _vm.itemId,"exact":""}},[_c('p',[_vm._v(_vm._s(_vm.name))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379da0c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./uncommon-client/components/gold-admin/Item.vue
// module id = null
// module chunks = 